export const CSS_HEX_GREEN = '#00D592'
export const CSS_HEX_ORANGE = '#FFB300'
export const CSS_HEX_RED = '#E20039'
export const CSS_HEX_WHITE = '#FFFFFF'

export const CSS_RGBA_GREEN = 'rgba(0, 213, 146, 0.25)'
export const CSS_RGBA_ORANGE = 'rgba(255, 179, 0, 0.25)'
export const CSS_RGBA_RED = 'rgba(226, 0, 57, 0.25)'
export const CSS_RGBA_WHITE = 'rgba(255, 255, 255, 0.25)'
